import { useState } from 'react';
import { compareTabs } from '@/mocks/home';

export default function CompareTabs() {
  const [active, setActive] = useState(compareTabs[0].id);
  const current = compareTabs.find((tab) => tab.id === active) ?? compareTabs[0];

  return (
    <section id="compare" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-2xl">
          <span className="text-primary-600 font-label text-sm tracking-wide">新旧对比</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            换个维度看差异
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            同一部作品，从视觉、叙事、演员到市场，答案完全不同。点选下面的维度标签，对照会实时切换。
          </p>
        </div>

        <div className="mt-8 reveal">
          <div className="flex flex-wrap gap-2 p-1.5 bg-background-100 rounded-full w-fit max-w-full">
            {compareTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActive(tab.id)}
                aria-pressed={active === tab.id}
                className={`px-4 md:px-5 py-1.5 rounded-full text-xs md:text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                  active === tab.id
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
            <div className="bg-background-100 rounded-lg border border-background-200/80 p-6 md:p-7">
              <div className="flex items-center gap-2 text-foreground-600 text-xs font-label">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-history-line text-xs" />
                </span>
                原版 · 1993
              </div>
              <p className="mt-4 text-foreground-800 text-sm md:text-base leading-relaxed">
                {current.original}
              </p>
            </div>

            <div className="bg-background-950 rounded-lg border border-background-800 p-6 md:p-7 text-background-50">
              <div className="flex items-center gap-2 text-background-50/70 text-xs font-label">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
                  <i className="ri-flashlight-line text-xs" />
                </span>
                3D 版 · 2011
              </div>
              <p className="mt-4 text-background-50/85 text-sm md:text-base leading-relaxed">
                {current.remake}
              </p>
            </div>
          </div>

          <div className="mt-4 flex items-start gap-3 bg-accent-50 border border-accent-200/70 rounded-lg p-5 md:p-6">
            <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-lightbulb-line" />
            </span>
            <div>
              <p className="text-accent-900 font-label text-xs md:text-sm">差异小结</p>
              <p className="mt-1 text-foreground-700 text-sm md:text-base leading-relaxed">{current.diff}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}